import moment from 'moment';
import Api from '../Api';
import { parseUnits, submitsToHashrate } from '../utils';

export default class MinerRigsTable {
    constructor(divToAppend, coin = 'bch') {
        this.coin = coin;
        this.container = divToAppend;

        divToAppend.innerHTML = `
        <div class="card">
            <div class="card-table table-responsive">
                <table class="table">
                    <thead>
                        <tr>
                            <th>RIG</th>
                            <th>Hash 60min</th>
                            <th>Valid submits</th>
                            <th>avg. diff</th>
                            <th>Last seen</th>
                        </tr>
                    </thead>
                    <tbody></tbody>
                </table>
            </div>
        </div>`;
    }

    async render(generatedWork) {
        const tbody = this.container.querySelector('tbody');
        tbody.innerHTML = '';
        for (const rig in generatedWork) {
            // eslint-disable-next-line no-undef
            const tr = document.createElement('tr');
            const val = generatedWork[rig];
            let hashrate = submitsToHashrate(val.work, 60 * 60);
            // if (this.coin == 'rvn') hashrate = hashrate / 256;

            tr.innerHTML = `
            <td>${rig}</td>
            <td>${parseUnits(hashrate)}</td>
            <td>${val.qty}</td>
            <td>${parseUnits(this.coin == 'rvn' ? val.avgDiff * 256 : val.avgDiff, '')}</td>
            <td>${moment(val.lastSubmit).from()}</td>`;

            tbody.appendChild(tr);
        }
    }
}